import { render, staticRenderFns } from "./sync-status.vue?vue&type=template&id=bff7648e"
import script from "./sync-status.vue?vue&type=script&lang=ts"
export * from "./sync-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports